/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GenericTableResponse } from '../../models/generic-table-response';

export interface GetUnassignedCases$Params {

/**
 * a parameter to filter out cases based on the due date
 */
  due_to: string;
}

export function getUnassignedCases(http: HttpClient, rootUrl: string, params: GetUnassignedCases$Params, context?: HttpContext): Observable<StrictHttpResponse<GenericTableResponse>> {
  const rb = new RequestBuilder(rootUrl, getUnassignedCases.PATH, 'get');
  if (params) {
    rb.query('due_to', params.due_to, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GenericTableResponse>;
    })
  );
}

getUnassignedCases.PATH = '/api/v1/statistics-dashboard/unassigned_cases';
